import { render, staticRenderFns } from "./listConfig.vue?vue&type=template&id=63c2d49a"
import script from "./listConfig.vue?vue&type=script&lang=js"
export * from "./listConfig.vue?vue&type=script&lang=js"
import style0 from "./listConfig.vue?vue&type=style&index=0&id=63c2d49a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports